import React from 'react'
import { AricleList } from '../aricle/index'
import './index.less'

export const RightPanel = () => {
  return <div className="right-panel">
    <AricleList />
  </div>
}
